const envVars = process.env;

export const configuration = {
  baseUrl: envVars.REACT_APP_SERVICE_BASE_URL || "https://ai-pplx-poc.azurewebsites.net/api",
  googleAnalyticsKey: envVars.REACT_APP_GA_KEY || "G-Q84V6RBT1Z"
};
